module.exports = __webpack_public_path__ + "static/investiv.2dbab963.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/investiv.jpg
// module id = 911
// module chunks = 3